<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      充值处理
    </p>
    <div class="search">
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
    <EditSuccess
    :ApplyId="ApplyId"
    :editModal="editModal"
    :flowNumble="flowNumble"
    :imgArr="imgArr"
    :price="price"
    @callback="loadList()"
    @backeditModal= "editModal = false"
    />
  </Card>
  <PicsModal
    :pics="picList"
    :visible="picModel"
    :index="picIndex"
    @on-close="picModel = false"
  />
 </div>
</template>

<script>
import { mapState } from 'vuex'

import PicsModal from '@/components/PicsModal'
import EditSuccess from './EditSuccess'

export default {
  components: {
    EditSuccess,
    PicsModal
  },
  data () {
    return {
      editModal: false,
      price: 0,
      ApplyId: 0,
      flowNumble: '',
      imgArr: '',
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      picIndex: 0,
      picModel: false,
      picList: []
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let setBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.ApplyId = row.id
                  this.flowNumble = row.flow_no
                  this.imgArr = row.img_urls
                  this.editModal = true
                  this.price = row.price
                }
              },
              style: {
                marginLeft: '10px'
              }
            }, ['确认充值'])
            return h('span', [
              setBtn
            ])
          }
        },
        {
          title: '申请时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '充值金额',
          key: 'price',
          width: 140
        },
        {
          title: '代理商',
          key: 'agent_name',
          width: 140
        },
        {
          title: '开户行',
          key: 'bank_name',
          width: 140
        },
        {
          title: '对公账号',
          key: 'bank_account',
          width: 140
        },
        {
          title: '流水单号',
          key: 'flow_no',
          width: 140
        },
        {
          title: '付款凭证图片',
          width: 140,
          align: 'center',
          render: (h, { row }) => {
            let check = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.picIndex = this.index
                  this.picList = row.img_urls ? row.img_urls.split(',') : []
                  this.picModel = true
                }
              }
            }, ['查看'])
            return h('span', [check])
          }
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/agent/account/recharge/list', {
          params: {
            type: 1,
            handle_state: 1,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/agent/account/recharge/count', {
          params: {
            type: 1,
            handle_state: 1
          }
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    showPicList (index) {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picIndex = index
      this.picModel = true
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    editReport () {
      this.editReportCurstom = true
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/handle/topUpManage/index.vue